import { useEffect, useRef } from 'react';

import type { SegmentId } from '@hotjar/webapp/features/Recordings/types';

export function useSegmentReset(segmentId: SegmentId | null, onReset: () => void): void {
  const previousSegmentId = useRef(segmentId);
  useEffect(() => {
    if (segmentId === previousSegmentId.current) {
      return;
    }

    onReset();
  }, [segmentId, onReset]);
}
